import { motion } from 'framer-motion'

// Slim proof band directly under the hero — specific numbers, no cards,
// no icons.
const PROOF_STATS = [
  { value: '10k+', label: 'players on Statbox' },
  { value: '100k+', label: 'highlights delivered' },
  { value: '50+', label: 'courts supported' },
  { value: '20+', label: 'communities and academies worldwide' },
]

export const ProofStrip = () => {
  return (
    <section aria-label="Statbox by the numbers" className="relative bg-black">
      <div className="mx-auto w-full max-w-[1280px] px-5 sm:px-8">
        <motion.dl
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="grid grid-cols-2 md:grid-cols-4 border-y border-white/[0.07]"
        >
          {PROOF_STATS.map(({ value, label }, i) => (
            <div
              key={label}
              className={[
                'flex flex-col-reverse items-center justify-center gap-1.5 px-3 py-7 sm:py-9 text-center',
                i % 2 === 1 ? 'border-l border-white/[0.07]' : '',
                i >= 2 ? 'border-t border-white/[0.07] md:border-t-0' : '',
                i >= 1 ? 'md:border-l md:border-white/[0.07]' : '',
              ].join(' ')}
            >
              <dt className="text-[12px] sm:text-[13px] leading-snug text-white/45 max-w-[180px]">
                {label}
              </dt>
              <dd className="text-[26px] sm:text-[32px] font-extrabold tracking-tight text-white tabular-nums leading-none">
                {value}
              </dd>
            </div>
          ))}
        </motion.dl>
      </div>
    </section>
  )
}
